import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { DialogActions, Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useFormikContext } from 'formik';
import { LoadingButton } from '~/modules/common/components';

const SetResourceAllocationDialogFooter = ({
  onFormSubmit,
  isSmartFitOpen,
  isSaving,
  onClose
}) => {
  const { values } = useFormikContext();

  const onSubmit = useCallback(() => {
    onFormSubmit(values);
  }, [onFormSubmit, values]);

  const isDisabled = isSmartFitOpen || isSaving;

  return (
    <DialogActions>
      <Button
        data-qe-id="SetResourceAllocationDialog_CancelButton"
        disabled={isDisabled}
        onClick={onClose}
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.cancel" />
      </Button>
      <LoadingButton
        color="primary"
        data-qe-id="SetResourceAllocationDialog_SubmitButton"
        disabled={isDisabled}
        isLoading={isDisabled}
        onClick={onSubmit}
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.setResourceAllocation" />
      </LoadingButton>
    </DialogActions>
  );
};

SetResourceAllocationDialogFooter.propTypes = {
  onFormSubmit: PropTypes.func.isRequired,
  isSmartFitOpen: PropTypes.bool,
  isSaving: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

export default SetResourceAllocationDialogFooter;
